import { useState } from "react";

export const useSpreadRefreshInterval = (baseIntervalMs: number | undefined): number | false => {
  const [intervalMs] = useState<number | false>(() =>
    baseIntervalMs === undefined ? false : Math.round(baseIntervalMs * (1 + Math.random()))
  );

  return intervalMs;
};
